var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th-card',{staticClass:"h-100"},[_c('h6',[_vm._v(_vm._s(_vm.$translation.t("Consent Ratio")))])])}
var staticRenderFns = []

export { render, staticRenderFns }